import welcome from '@lotties/badges/welcome.json';
import friday_the_13 from '@lotties/badges/friday_the_13.json';
import i_hate_mondays from '@lotties/badges/i_hate_mondays.json';
import thank_god_its_friday from '@lotties/badges/thanks_god_its_friday.json';
import comeback_kid from '@lotties/badges/comeback_kid.json';
import may_the_4 from '@lotties/badges/may-the-4th.json';
import perfect_week from '@lotties/badges/perfect_week.json';
import perfect_month from '@lotties/badges/perfect_month.json';

export const Welcome ={
    loop: true,
    animationData: welcome,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
};

export const Friday_the_13 ={
    loop: true,
    animationData: friday_the_13,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
};

export const I_hate_mondays ={
    loop: true,
    animationData: i_hate_mondays,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
};

export const Thank_god_its_friday ={
    loop: true,
    animationData: thank_god_its_friday,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
};

export const Comeback_kid ={
    loop: true,
    animationData: comeback_kid,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
};

export const May_the_4 ={
    loop: true,
    animationData: may_the_4,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
};

export const Perfect_week ={
    loop: true,
    animationData: perfect_week,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
};

export const Perfect_month ={
    loop: true,
    animationData: perfect_month,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
};